/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CustomRoleUpdateRequest extends models.RoleBase {
    getFixupPrototypeFunction() { return CustomRoleUpdateRequest.fixupPrototype; }

    static newInstance(model: Partial<CustomRoleUpdateRequest>): CustomRoleUpdateRequest {
        let obj = Object.assign(new CustomRoleUpdateRequest(), model);
        CustomRoleUpdateRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CustomRoleUpdateRequest>): CustomRoleUpdateRequest {
        if (!model) return null;
        return CustomRoleUpdateRequest.newInstance(<CustomRoleUpdateRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CustomRoleUpdateRequest) {
        if (!obj) return;

        models.CustomRoleUpdateRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CustomRoleUpdateRequest): boolean {
        if (models.RoleBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CustomRoleUpdateRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Name of the role. This must be unique within the tenant
     */
    name: string;

    /**
     * Permission policies for the role, keyed by policy name
     */
    policies: any;

    /**
     * Resource IDs the role is scoped to
     */
    resources: Array<string>;

}
